export default __webpack_public_path__ + "static/cardImg1-0025e46e03ea5b9e3eba6b1fc715863f.webp";